import React, { useState, useEffect } from "react";
import LcAccordion from "../../../../../components/Generic/LcAccordion";
import AlertNotification from "../../../../../components/Dialog/AlertNotification";
import FastSolicitationService from "../../../../../services/FastSolicitationService/FastSolicitationService";
import { ReopenSolicitation } from "../../../../../models/FastSolicitation";
import LcLoading from "../../../../../components/Generic/LcLoading";
import "./index.css";
import { PPTextArea } from "processor-plataform-ui";
import { Validation } from "../../../../../services/TextTools/TextTools";

interface Props {
    reopen: boolean,
    solicitation: any,
    user: any,
    handleCloseReopen: Function,
    reopenClose: Function
    getSolicitationsType?: Function
}

type AlertColor = "success" | "info" | "warning" | "error";

const SolicitationDetailsReopen: React.FC<Props> = (props) => {
    const fastSolicitationService = new FastSolicitationService(props);
    const [motive, setMotive] = useState<string>("");
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [message, setMessage] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [validations, setValidations] = useState<Validation[]>([]);
    const onChangeMotive = (e: any) => setMotive(e.target.value);
    const handleCloseNotification = () => setOpenNotificacao(false);

    const validateRules = () => {
        var validationsChecks: Validation[] = [];

        if (!(motive.length > 0)) {
            validationsChecks.push({
                name: "motive",
                message: "Preencha uma justificativa válida",
                valid: false
            });
        }

        if (validationsChecks.length !== 0) {
            setValidations(validationsChecks);
        }

        return validationsChecks.length === 0;
    }

    const notificationValidation = (mensagem: string, tipo: AlertColor) => {
        setMessage(mensagem);
        setSeverity(tipo);
        setOpenNotificacao(true);
    }

    const handleClick = async () => {
        setLoading(true);

        if (validateRules() === false) {
            setLoading(false);
            return true;
        }

        let comment = {
            solicitationId: props.solicitation.id,
            comment: motive,
        }

        try {
            await fastSolicitationService.reopenSolicitation(comment as ReopenSolicitation);
            props.solicitation.idStatus = 9;
            props.handleCloseReopen();
            props.reopenClose();
            props.getSolicitationsType && props.getSolicitationsType();
            notificationValidation("Solicitação reaberta com sucesso!", "success");
        }
        catch (error) {
            console.log(error);
            debugger
        }

        setLoading(false);
    }

    return (
        <>
            {
                props.reopen &&
                <div className={"divOrderDetailsReopen"}>
                    <LcLoading loading={loading} label={"Carregando..."}>
                        <LcAccordion title={"Reabrir"} visible={true} iconNormal={true} >
                            <div style={{ paddingBottom: 10 }}>
                                <PPTextArea
                                    name={"motive"}
                                    onChange={onChangeMotive}
                                    required={true}
                                    rows={5}
                                    width={"28rem"}
                                    autoheight
                                    error={{
                                        show: validations.find(x => "motive" === x.name) !== undefined,
                                        help: validations.find(x => "motive" === x.name)?.message
                                    }}
                                />
                            </div>
                            <button type={"button"} className={"lc-button bg-info"} onClick={() => handleClick()} style={{ width: "100px" }}> Reabrir </button>
                        </LcAccordion>
                    </LcLoading>
                </div>
            }

            <AlertNotification open={openNotificacao} severity={severity} message={message} handleClose={handleCloseNotification} />
        </>
    );
};

export default SolicitationDetailsReopen;